{
  "LogFileDownload_DownloadTitle": "Download **{}**",
  "LogFileDownload_HowManyFiles": "How many previous files would you like to download?",
  "LogFileDownload_AllFiles": "All files",
  "LogFileDownload_NFile": "Past {} file(s)",
  "LogFileDownload_CurrentFile": "Current file",
  "NAME": "LanguageLogFileDownload"
}